export const scriptBlueConic = {
	'es-CO': [
		{
			type: 'text/javascript',
			src: 'https://l002.tena.com.co/script.js',
		}
	],
     es: []
}